import { Box, BoxProps } from '@mui/material';
import useViewportMode, { ViewportMode } from '../../hooks/useViewportMode';

export interface MobileFormStackProps extends BoxProps {
    tabletColumns?: number;
    desktopColumns?: number;
    viewportOverride?: ViewportMode;
}

const columnTemplate = (columns: number) => `repeat(${Math.max(1, columns)}, minmax(0, 1fr))`;

const MobileFormStack = ({
    tabletColumns = 2,
    desktopColumns = 1,
    viewportOverride,
    sx,
    ...boxProps
}: MobileFormStackProps) => {
    const viewport = useViewportMode();
    const mode = viewportOverride ?? viewport.mode;
    const columns = mode === 'phone' ? 1 : mode === 'tablet' ? tabletColumns : desktopColumns;

    return (
        <Box
            {...boxProps}
            data-testid="mobile-form-stack"
            data-form-columns={columns}
            sx={{
                display: 'grid',
                gridTemplateColumns: columnTemplate(columns),
                gap: mode === 'phone' ? 2 : 3,
                minWidth: 0,
                '& > *': { minWidth: 0 },
                '& .MuiFormControl-root': { width: '100%' },
                ...((mode === 'phone' || mode === 'tablet') && {
                    '& .MuiButtonBase-root, & .MuiInputBase-root': { minHeight: 44 },
                }),
                ...sx,
            }}
        />
    );
};

export default MobileFormStack;
